import React from "react";
import {
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  SET_MAP_VIEW,
  SET_SHOW_STEWARDS,
  SET_SHOW_POULTRIES,
  SET_SHOW_LiveStocks,
  SET_SHOW_INSPECTIONS,
} from "../../../../lib/redux/slices/appSlice";
import { Grid } from "../../../../components/grid/Grid";
import {
  SET_FILTER_STATE,
  SET_FILTER_TYPE,
  SET_FILTERED_STEWARDS,
  SET_LIVESTOCK_TYPE,
} from "../../../../lib/redux/slices/mainSlice";

const liveStockTypeOptions = [
  { label: "همه", value: "all" },
  { label: "روستایی", value: "rural" },
  { label: "صنعتی", value: "industrial" },
];

export const MainAddFilter = () => {
  const dispatch = useDispatch();
  const {
    showStewards,
    showPoultries,
    mapViewIndex,
    showLiveStocks,
    showInspections,
  } = useSelector((state) => state.appSlice);
  const {
    poultryLocations,
    stewardsData,
    inspectionKeys,
    filterType,
    liveStockLocations,
    liveStockType,
    poultryScienceData,
    pending,
  } = useSelector((state) => state.mainSlice);

  const isFilterDisabled = pending;

  const handleLayerSelection = (layer) => {
    if (isFilterDisabled) return;

    // Dispatch the appropriate toggle action for each layer
    switch (layer) {
      case "stewards":
        dispatch(SET_SHOW_STEWARDS());
        break;
      case "poultries":
        dispatch(SET_SHOW_POULTRIES());
        break;
      case "livestocks":
        dispatch(SET_SHOW_LiveStocks());
        break;
      case "inspections":
        dispatch(SET_SHOW_INSPECTIONS());
        break;
      default:
        break;
    }
  };

  const handleFilterInspections = (value) => {
    if (value !== "showAll") {
      dispatch(SET_FILTER_STATE(true));
      if (value === "showInspects") {
        dispatch(
          SET_FILTERED_STEWARDS(
            stewardsData.filter((item) =>
              inspectionKeys.some((place) => place.placeKey === item.key)
            )
          )
        );
      } else if (value === "showNotInspects") {
        dispatch(
          SET_FILTERED_STEWARDS(
            stewardsData.filter(
              (item) =>
                !inspectionKeys.some((place) => place.placeKey === item.key)
            )
          )
        );
      } else if (value === "hasInfractions") {
        dispatch(
          SET_FILTERED_STEWARDS(
            stewardsData.filter((item) =>
              inspectionKeys.some(
                (place) =>
                  place.placeKey === item.key && place.hasInfractions === true
              )
            )
          )
        );
      } else if (value === "deactive") {
        const now = new Date();
        const twentyFourHoursAgo = new Date(
          now.getTime() - 24 * 60 * 60 * 1000
        );
        dispatch(
          SET_FILTERED_STEWARDS(
            stewardsData.filter((item) => {
              const lastSeenDate = new Date(item.session_last_seen_date);
              return lastSeenDate < twentyFourHoursAgo;
            })
          )
        );
      } else if (value === "online") {
        const now = new Date();
        const twentyFourHoursAgo = new Date(
          now.getTime() - 24 * 60 * 60 * 1000
        );
        dispatch(
          SET_FILTERED_STEWARDS(
            stewardsData.filter((item) => {
              const lastSeenDate = new Date(item.session_last_seen_date);
              return lastSeenDate > twentyFourHoursAgo;
            })
          )
        );
      } else if (value === "off") {
        const now = new Date();
        const twentyFourHoursAgo = new Date(
          now.getTime() - 48 * 60 * 60 * 1000
        );
        dispatch(
          SET_FILTERED_STEWARDS(
            stewardsData.filter((item) => {
              const lastSeenDate = new Date(item.session_last_seen_date);
              return lastSeenDate < twentyFourHoursAgo;
            })
          )
        );
      } else if (value === "hasTransaction") {
        dispatch(
          SET_FILTERED_STEWARDS(
            stewardsData.filter((item) => item?.pos?.transactions > 0)
          )
        );
      }
    } else {
      dispatch(SET_FILTER_STATE(false));
    }
  };

  return (
    <Grid xs={12} container direction="column" gap={1}>
      <Card
        variant="outlined"
        sx={{ borderRadius: 2, backgroundColor: "#f9f9f9" }}
      >
        <CardContent>
          <Grid container spacing={2}>
            <Grid xs={6}>
              <Typography variant="subtitle2" color="textSecondary">
                اصناف: {stewardsData?.length} عدد
              </Typography>
            </Grid>
            <Grid xs={6}>
              <Typography variant="subtitle2" color="textSecondary">
                مرغداران: {poultryLocations?.length} عدد
              </Typography>
            </Grid>
            <Grid xs={6}>
              <Typography variant="subtitle2" color="textSecondary">
                دامداران: {liveStockLocations?.length} عدد
              </Typography>
            </Grid>
            <Grid xs={6}>
              <Typography variant="subtitle2" color="textSecondary">
                بازرسی ها: {poultryScienceData?.length} عدد
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <Grid container xs={12} justifyContent="space-between">
        <Grid container justifyContent="start" xs={6}>
          <Card
            variant="outlined"
            sx={{ borderRadius: 2, backgroundColor: "#ffffff", width: "100%" }}
          >
            <CardContent>
              <FormControl component="fieldset">
                <FormLabel
                  component="legend"
                  sx={{ marginBottom: 1, color: "primary.main" }}
                >
                  فیلتر نمایش
                </FormLabel>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={isFilterDisabled}
                      checked={showStewards}
                      onChange={() => handleLayerSelection("stewards")}
                      color="primary"
                    />
                  }
                  label="اصناف"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={isFilterDisabled}
                      checked={showPoultries}
                      onChange={() => handleLayerSelection("poultries")}
                      color="primary"
                    />
                  }
                  label="مرغداران"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={isFilterDisabled || !liveStockLocations?.length}
                      checked={showLiveStocks}
                      onChange={() => handleLayerSelection("livestocks")}
                      color="primary"
                    />
                  }
                  label="دامداران"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={isFilterDisabled || !poultryScienceData?.length}
                      checked={showInspections}
                      onChange={() => handleLayerSelection("inspections")}
                      color="primary"
                    />
                  }
                  label="بازرسی ها"
                />
                {showLiveStocks && (
                  <RadioGroup
                    value={liveStockType ?? ""}
                    onChange={(event) =>
                      dispatch(SET_LIVESTOCK_TYPE(event.target.value))
                    }
                    sx={{
                      pl: 2,
                      mt: 1,
                    }}
                  >
                    {liveStockTypeOptions.map((option) => (
                      <FormControlLabel
                        key={option.value}
                        value={option.value}
                        control={
                          <Radio
                            size="small"
                            color="primary"
                            disabled={isFilterDisabled}
                          />
                        }
                        label={option.label}
                        sx={{ mr: 0 }}
                        disabled={isFilterDisabled}
                      />
                    ))}
                  </RadioGroup>
                )}
              </FormControl>
            </CardContent>
          </Card>
        </Grid>
        <Grid container justifyContent="end" xs={6}>
          <Card
            variant="outlined"
            sx={{ borderRadius: 2, backgroundColor: "#ffffff", width: "100%" }}
          >
            <CardContent>
              <FormControl component="fieldset">
                <FormLabel
                  component="legend"
                  sx={{ marginBottom: 1, color: "primary.main" }}
                >
                  انتخاب ظاهر نقشه
                </FormLabel>
                <RadioGroup>
                  <FormControlLabel
                    value="best"
                    control={
                      <Radio
                        checked={mapViewIndex === 1}
                        onChange={() =>
                          dispatch(
                            SET_MAP_VIEW({
                              mapAttribution:
                                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                              mapUrl:
                                "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                              mapViewIndex: 1,
                            })
                          )
                        }
                      />
                    }
                    label="ساده"
                  />
                  <FormControlLabel
                    value="modern"
                    control={
                      <Radio
                        checked={mapViewIndex === 2}
                        onChange={() =>
                          dispatch(
                            SET_MAP_VIEW({
                              mapAttribution:
                                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Tiles style by <a href="https://www.hotosm.org/" target="_blank">Humanitarian OpenStreetMap Team</a> hosted by <a href="https://openstreetmap.fr/" target="_blank">OpenStreetMap France</a>',
                              mapUrl:
                                "https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png",
                              mapViewIndex: 2,
                            })
                          )
                        }
                      />
                    }
                    label="مدرن"
                  />
                  <FormControlLabel
                    value="amber"
                    control={
                      <Radio
                        checked={mapViewIndex === 3}
                        onChange={() =>
                          dispatch(
                            SET_MAP_VIEW({
                              mapAttribution:
                                '<a href="https://github.com/cyclosm/cyclosm-cartocss-style/releases" title="CyclOSM - Open Bicycle render">CyclOSM</a> | Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                              mapUrl:
                                "https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png",
                              mapViewIndex: 3,
                            })
                          )
                        }
                      />
                    }
                    label="کهربایی"
                  />
                </RadioGroup>
              </FormControl>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <Grid container xs={12} justifyContent="center" alignItems="center">
        <FormControl>
          <InputLabel id="city-select-label">نمایش</InputLabel>
          <Select
            labelId="city-select-label"
            id="city-select"
            value={filterType ? filterType : "showAll"}
            disabled={isFilterDisabled}
            onChange={(event) => {
              dispatch(SET_FILTER_TYPE(event.target.value));
              handleFilterInspections(event.target.value);
            }}
          >
            <MenuItem value="showAll">نمایش همه</MenuItem>
            <MenuItem value="hasTransaction">دارای تراکنش</MenuItem>
            <MenuItem value="showInspects">بازرسی شده ها</MenuItem>
            <MenuItem value="showNotInspects">بازرسی نشده ها</MenuItem>{" "}
            <MenuItem value="hasInfractions">متخلفین</MenuItem>
            <MenuItem value="online">فعال (24 ساعت گذشته)</MenuItem>
            <MenuItem value="deactive">غیر فعال (24 ساعت گذشته)</MenuItem>
            <MenuItem value="off">خاموش</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
};
